import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
import {initReactI18next} from 'react-i18next'

import {
  DEFAULT_LANGUAGE,
  getCurrentLanguage,
  LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
  SUPPORTED_LANGUAGES,
  writeStoredLanguage,
} from './language'

export {
  DEFAULT_LANGUAGE,
  getCurrentLanguage,
  getLocaleChunkName,
  LANGUAGE_STORAGE_KEY,
  resolveLanguage,
  SUPPORTED_LANGUAGES,
} from './language'

// 服务端按 chunk 名预加载语言包，改名需同步 getLocaleChunkName
const loadResource = (language: string, namespace: string) => {
  const folder = normalizeLanguage(language) || language
  return import(
    /* webpackChunkName: "locale-[request]" */ `./locales/${folder}/${namespace}.json`
  )
}

const languageDetector = new LanguageDetector()
const deviceInfoLanguageDetector = {
  name: 'deviceInfo',
  lookup() {
    return getCurrentLanguage()
  },
  cacheUserLanguage(language: string) {
    const normalizedLanguage = normalizeLanguage(language)
    if (typeof window !== 'undefined' && normalizedLanguage) {
      writeStoredLanguage(normalizedLanguage)
    }
  },
}

languageDetector.addDetector(deviceInfoLanguageDetector)

export const i18nInitPromise = i18next
  .use(resourcesToBackend(loadResource))
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    detection: {
      order: ['deviceInfo', 'querystring', 'localStorage'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    fallbackLng: DEFAULT_LANGUAGE,
    // 同时声明 App 原始码与 i18next 格式化后的码，避免 zh-rHK 被格式化成 zh-RHK 后落入 fallback
    supportedLngs: [...SUPPORTED_LANGUAGES, 'zh-RHK', 'zh-RTW'],
    load: 'currentOnly',
    ns: 'translation',
    returnEmptyString: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })

export const getLanguages = async () => {
  const languages = (await import('./locales/languages.json')).default
  return languages
}

export default i18next
